import script from "./machine.vue?vue&type=script&setup=true&lang=ts"
export * from "./machine.vue?vue&type=script&setup=true&lang=ts"

import "./machine.vue?vue&type=style&index=0&id=02f09cbb&scoped=true&lang=stylus"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02f09cbb"]])

export default __exports__